<template>
  <div>
    <transition name="fade" mode="out-in">
      <small class="text-danger" v-if="message">{{ message }}</small>
    </transition>
    <transition name="fade" mode="out-in">
      <i
        v-if="message"
        class="fa fa-times fa-lg icon-error"
        :data-title="message"
        data-toggle="tooltip"
        data-container="body"
      ></i>
    </transition>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  name: 'error-message',
  props: {
    message: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/ErrorMessage.vue